module.exports = __webpack_public_path__ + "static/media/angular-icon-seeklogo.3230b352.svg";